import React, { Component } from "react"

export class CloseIcon extends Component {
  render() {
    return (
      <span className="icon icon-close" aria-hidden="true">
       <svg xmlns="http://www.w3.org/2000/svg" className="" viewBox="0 0 24 24"><path className="fill" d="M12 0a12 12 0 1 0 12 12A12 12 0 0 0 12 0zm4.71 15.29a1 1 0 0 1-1.42 1.42L12 13.41l-3.29 3.3a1 1 0 0 1-1.42-1.42l3.3-3.29-3.3-3.29a1 1 0 0 1 1.42-1.42l3.29 3.3 3.29-3.3a1 1 0 0 1 1.41 0 1 1 0 0 1 0 1.42L13.41 12z"></path></svg>
      </span>
    )
  }
}
export class DownIcon extends Component {
  render() {
    return (
      <span className="icon icon-down" aria-hidden="true">
        <svg id="Layer_1" className="icon" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path className="fill" d="M10.4 19l-8-10.63A2 2 0 0 1 4 5.17h16a2 2 0 0 1 1.6 3.2L13.6 19a2 2 0 0 1-2.8.4 1.69 1.69 0 0 1-.4-.4z"/></svg>
      </span>
    )
  }
}
export class SearchIcon extends Component {
  render() {
    return (
      <span className="icon icon-search" aria-hidden="true">
        <svg xmlns="http://www.w3.org/2000/svg" role="img" width="24px" height="24px" viewBox="0 0 24 24">
          <path className="fill" d="M5 9a5 5 0 1 1 5 5 5 5 0 0 1-5-5m16.71 11.29l-6.56-6.56A7 7 0 1 0 13.59 15l6.7 6.71a1 1 0 0 0 1.41 0 1 1 0 0 0 0-1.42"/>
        </svg>
      </span>
    )
  }
}
export class EbookIcon extends Component {
  render() {
    return (
      <span className="icon icon-ebook" aria-hidden="true">
        <svg xmlns="http://www.w3.org/2000/svg" role="img" width="24px" height="24px" viewBox="0 0 24 24">
        <path className="fill" d="M15 19.4v-12L6 5.45V19.9l7.79 1.66a1 1 0 0 0 1.21-.74V19.4zm2-.85a1 1 0 0 0 1-1V4.4L9 2.45v1.6l6.42 1.35a2 2 0 0 1 1.58 2zm0 2a3 3 0 0 1-3 3 2.7 2.7 0 0 1-.63-.07l-7.79-1.63A2 2 0 0 1 4 19.9V5.45A2 2 0 0 1 6 3.4a1.83 1.83 0 0 1 .47.05l.53.17V2.45A2 2 0 0 1 9.42.5l9 1.92A2 2 0 0 1 20 4.4v13.17a3 3 0 0 1-3 3z"/>
        </svg>
      </span>
    )
  }
}

export class PlayIcon extends Component {
  render() {
    return (
      <span className="icon icon-play" aria-hidden="true">
        <svg xmlns="http://www.w3.org/2000/svg" role="img" width="24px" height="24px" viewBox="0 0 24 24">
        <path className="fill" d="M21.07 10.38L5.1.31A2.87 2.87 0 0 0 3.6.08a1.56 1.56 0 0 0-1.77 1.71v20.57a1.58 1.58 0 0 0 1.77 1.71 2.87 2.87 0 0 0 1.5-.23l16-10.06c1.31-.78 1.08-1.7 1.08-1.7s.2-.92-1.11-1.7z"/>
        </svg>
      </span>
    )
  }
}

export class VideoIcon extends Component {
  render() {
    return (
      <span className="icon icon-video" aria-hidden="true">
        <svg xmlns="http://www.w3.org/2000/svg" role="img" width="24px" height="24px" viewBox="0 0 24 24">
        <path className="fill" d="M15.2 12.14l-4.28-3.06v6.12zm-3.12 4.68a2 2 0 0 1-2.79-.46 2 2 0 0 1-.37-1.16V9.08a2 2 0 0 1 2-2 2 2 0 0 1 1.16.37l4.28 3.06a2 2 0 0 1 .47 2.79 2.1 2.1 0 0 1-.47.47zM12 24a12 12 0 1 1 12-12 12 12 0 0 1-12 12zm0-2A10 10 0 1 0 2 12a10 10 0 0 0 10 10z"/>
        </svg>
      </span>
    )
  }
}

export class ArticleIcon extends Component {
  render() {
    return (
      <span className="icon icon-article" aria-hidden="true">
        <svg xmlns="http://www.w3.org/2000/svg" role="img" width="24px" height="24px" viewBox="0 0 24 24">
          <path className="fill" d="M15 19.4v-12L6 5.45V19.9l7.79 1.66a1 1 0 0 0 1.21-.74V19.4zm2-.85a1 1 0 0 0 1-1V4.4L9 2.45v1.6l6.42 1.35a2 2 0 0 1 1.58 2zm0 2a3 3 0 0 1-3 3 2.7 2.7 0 0 1-.63-.07l-7.79-1.63A2 2 0 0 1 4 19.9V5.45A2 2 0 0 1 6 3.4a1.83 1.83 0 0 1 .47.05l.53.17V2.45A2 2 0 0 1 9.42.5l9 1.92A2 2 0 0 1 20 4.4v13.17a3 3 0 0 1-3 3z"/>
        </svg>
      </span>
    )
  }
}

export class CheckedIcon extends Component {
  render() {
    return (
      <span className="icon icon-cheched" aria-hidden="true">
        <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <path className="fill" d="M20.32,4.67a1.56,1.56,0,1,1,2.24,2.17l0,0L10,19.35a1.55,1.55,0,0,1-2.2,0L1.48,13a1.56,1.56,0,1,1,2.16-2.24l0,0L8.94,16,20.32,4.67Z"/>
        </svg>
      </span>
    )
  }
}

export class PlusIcon extends Component {
  render() {
    return (
      <span className="icon icon-plus" aria-hidden="true">
        <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="20" height="20" viewBox="0 0 24 24">
            <defs>
                <path id="5lki3lis3a" d="M13 4v6.999L20 11v2h-7v7h-2v-7H4v-2h7V4h2z"/>
            </defs>
            <g fill="none" fillRule="evenodd">
                <g>
                    <mask id="q3lj9odrsb" fill="#fff">
                        <use href="#5lki3lis3a"/>
                    </mask>
                    <use fill="#979797" fillRule="nonzero" href="#5lki3lis3a"/>
                    <g fill="#000" fillRule="nonzero" mask="url(#q3lj9odrsb)">
                        <path d="M0 0H24V24H0z"/>
                    </g>
                </g>
            </g>
        </svg>
      </span>
    )
  }
}


export class CloseSmallIcon extends Component {
  render() {
    return (
      <span className="icon icon-plus" aria-hidden="true">
        <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="14" height="14" viewBox="0 0 28 28">
          <defs>
              <path id="h2s4mjezia" d="M12 .172c.552 0 1 .447 1 1V11h9.828c.553 0 1 .448 1 1s-.447 1-1 1H13v9.828c0 .553-.448 1-1 1s-1-.447-1-1V13H1.172c-.553 0-1-.448-1-1s.447-1 1-1H11V1.172c0-.553.448-1 1-1z"/>
          </defs>
          <g fill="none" fillRule="evenodd">
              <g>
                  <mask id="pskscgrttb" fill="#fff">
                      <use xlinkHref="#h2s4mjezia"/>
                  </mask>
                  <use fill="#82abab" transform="rotate(45 12 12)" xlinkHref="#h2s4mjezia"/>
              </g>
          </g>
        </svg>
      </span>
    )
  }
}

export class GreenDownIcon extends Component {
  render() {
    return (
      <span className="icon icon-plus" aria-hidden="true">
        <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24"><defs></defs><path id="a" fill="#8db5b5" className="cls-1" d="M10.4,19,2.4,8.37A2,2,0,0,1,4,5.17H20a2,2,0,0,1,1.6,3.2L13.6,19a2,2,0,0,1-2.8.4h0A1.9,1.9,0,0,1,10.4,19Z"/></svg>
      </span>
    )
  }
}

export class CollectionEndcap extends Component {
  render() {
    return (
      <span className="icon icon-plus" aria-hidden="true">
        <svg width="64px" height="201px" viewBox="0 0 64 201" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
          <title>listings-image-endcap</title>
          <g id="Category-Listings" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <path d="M29,102.5 C29,143.013938 42.4512147,179.344127 63.7307828,204.002699 L0,204 L0,1 L63.7317159,0.996220173 C42.4516079,25.6548108 29,61.9854701 29,102.5 Z" id="listings-image-endcap" fill="#FFFFFF"></path>
          </g>
        </svg>
      </span>
    )
  }
}

export class GreenRightIcon extends Component {
  render() {
    return (
      <span className="" aria-hidden="true">
        <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24"><defs></defs><path id="a" transform="rotate(-90 10 10)" fill="#8db5b5" className="cls-1" d="M10.4,19,2.4,8.37A2,2,0,0,1,4,5.17H20a2,2,0,0,1,1.6,3.2L13.6,19a2,2,0,0,1-2.8.4h0A1.9,1.9,0,0,1,10.4,19Z"/></svg>
      </span>
    )
  }
}

export class GreenLeftIcon extends Component {
  render() {
    return (
      <span className="" aria-hidden="true">
        <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24"><defs></defs><path id="a" transform="rotate(90 10 10)" fill="#8db5b5" className="cls-1" d="M10.4,19,2.4,8.37A2,2,0,0,1,4,5.17H20a2,2,0,0,1,1.6,3.2L13.6,19a2,2,0,0,1-2.8.4h0A1.9,1.9,0,0,1,10.4,19Z"/></svg>
      </span>
    )
  }
}

export class BlackLeftIcon extends Component {
  render() {
    return (
      <span className="" aria-hidden="true">
        <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24"><defs></defs><path id="a" transform="rotate(90 10 10)" fill="#000000" className="cls-1" d="M10.4,19,2.4,8.37A2,2,0,0,1,4,5.17H20a2,2,0,0,1,1.6,3.2L13.6,19a2,2,0,0,1-2.8.4h0A1.9,1.9,0,0,1,10.4,19Z"/></svg>
      </span>
    )
  }
}

export class EnquiryIcon extends Component {
  render() {
    return (
      <span className="" aria-hidden="true">
        <svg xmlns="http://www.w3.org/2000/svg" role="img" width="28" height="28" viewBox="-5 -5 28 28"><g fill="currentColor" fillRule="evenodd"><g fill="currentColor"><path d="M13.625 1l.035.002.105.002C18.613 1.144 22.5 5.118 22.5 10c0 4.97-4.03 9-9 9-2.428 0-4.632-.962-6.251-2.525-.03-.027-.057-.054-.083-.082l-.03-.029c-.17-.2-.274-.457-.274-.739 0-.621.504-1.125 1.125-1.125.283 0 .54.104.738.275l.002-.002c1.222 1.221 2.909 1.977 4.773 1.977 3.728 0 6.75-3.022 6.75-6.75s-3.022-6.75-6.75-6.75H1c-.552 0-1-.448-1-1V2c0-.552.448-1 1-1h12.625zM13.5 5.5c.577 0 1.052.434 1.117.994l.008.131v3.805l1.628.814c.516.258.747.859.555 1.388l-.052.121c-.258.516-.859.747-1.388.555l-.121-.052-2.25-1.125c-.339-.17-.567-.496-.613-.866l-.009-.14v-4.5c0-.621.504-1.125 1.125-1.125zM6.875 10c.552 0 1 .448 1 1v.25c0 .552-.448 1-1 1h-2.5c-.552 0-1-.448-1-1V11c0-.552.448-1 1-1h2.5zm0-4.5c.552 0 1 .448 1 1v.25c0 .552-.448 1-1 1h-4.75c-.552 0-1-.448-1-1V6.5c0-.552.448-1 1-1h4.75z" transform="translate(-204 -347) translate(188 324) translate(16 22)"/></g></g></svg>
      </span>
    )
  }
}

export class DisplayProductIcon extends Component {
  render() {
    return (
      <span className="" aria-hidden="true">
        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
            <g fill="none" fillRule="evenodd">
                <g stroke="#417171" strokeWidth="2">
                    <path d="M7 9h26c1.105 0 2 .895 2 2v10.316h0C35 24.456 32.455 27 29.316 27H10.684C7.544 27 5 24.455 5 21.316h0V11c0-1.105.895-2 2-2z" transform="matrix(1 0 0 -1 0 36)"/>
                    <path d="M4.295 30h31.41c.741 0 1.342.6 1.342 1.342 0 .23-.059.457-.172.658-.695 1.235-2.002 2-3.42 2H6.545c-1.418 0-2.725-.765-3.42-2-.363-.646-.134-1.464.512-1.828.2-.113.427-.172.658-.172z"/>
                    <circle cx="20" cy="6.5" r="2.5"/>
                </g>
            </g>
        </svg>
      </span>
    )
  }
}

export class BeverageProductIcon extends Component {
  render() {
    return (
      <span className="" aria-hidden="true">
        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
            <g fill="none" fillRule="evenodd">
                <g stroke="#417171" strokeWidth="2">
                    <rect width="28" height="8" x="6" y="16" rx="1"/>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M31 15c0-4.05-3.667-7.717-11-11-7.333 3.283-11 6.95-11 11"/>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M25 15c0-4.05-1.667-7.717-5-11-3.333 3.283-5 6.95-5 11"/>
                    <path d="M10 36c1.657 0 3-1.343 3-3 0-1.105-1-2.771-3-5-2 2.229-3 3.895-3 5 0 1.657 1.343 3 3 3zM20 36c1.657 0 3-1.343 3-3 0-1.105-1-2.771-3-5-2 2.229-3 3.895-3 5 0 1.657 1.343 3 3 3zM30 36c1.657 0 3-1.343 3-3 0-1.105-1-2.771-3-5-2 2.229-3 3.895-3 5 0 1.657 1.343 3 3 3z"/>
                </g>
            </g>
        </svg>
      </span>
    )
  }
}

export class CoffeeProductIcon extends Component {
  render() {
    return (
      <span className="" aria-hidden="true">
        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
            <g fill="none" fillRule="evenodd">
                <g stroke="#417171" strokeWidth="2">
                    <path d="M8 16h22c1.105 0 2 .895 2 2v7.474h0C32 31.287 27.287 36 21.474 36h-4.948C10.713 36 6 31.287 6 25.474h0V18c0-1.105.895-2 2-2zM32.138 26h1.675C36.125 26 38 24.21 38 22s-1.875-4-4.187-4h-1.675M20 12c1.657 0 3-1.343 3-3 0-1.105-1-2.771-3-5-2 2.229-3 3.895-3 5 0 1.657 1.343 3 3 3z"/>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M11 25.5c2.833-2 5.667-2 8.5 0s5.667 2 8.5 0"/>
                </g>
            </g>
        </svg>
      </span>
    )
  }
}

export class FridgeProductIcon extends Component {
  render() {
    return (
      <span className="" aria-hidden="true">
        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
            <g fill="none" fillRule="evenodd">
                <g>
                    <path stroke="#417171" strokeLinecap="round" strokeWidth="2" d="M11 4c2.21 0 4 1.79 4 4v16.377c1.522 1.19 2.5 3.042 2.5 5.123 0 3.59-2.91 6.5-6.5 6.5s-6.5-2.91-6.5-6.5c0-2.081.978-3.934 2.5-5.124V8c0-2.21 1.79-4 4-4z"/>
                    <circle cx="11" cy="29.5" r="3" fill="#417171"/>
                    <rect width="2" height="9" x="10" y="19" fill="#417171" rx="1"/>
                    <g stroke="#417171" strokeLinecap="round" strokeWidth="2">
                        <g>
                            <g>
                                <path d="M1 0.5L1 12.5" transform="translate(20 6) translate(6) translate(1 1.5)"/>
                            </g>
                            <path d="M0 0L2 2 4 0" transform="translate(20 6) translate(6)"/>
                            <path d="M0 14L2 16 4 14" transform="translate(20 6) translate(6) matrix(1 0 0 -1 0 30)"/>
                        </g>
                        <g>
                            <g>
                                <path d="M1 0.5L1 12.5" transform="translate(20 6) rotate(60 5 13.196) translate(1 1.5)"/>
                            </g>
                            <path d="M0 0L2 2 4 0" transform="translate(20 6) rotate(60 5 13.196)"/>
                            <path d="M0 14L2 16 4 14" transform="translate(20 6) rotate(60 5 13.196) matrix(1 0 0 -1 0 30)"/>
                        </g>
                        <g>
                            <g>
                                <path d="M1 0.5L1 12.5" transform="translate(20 6) scale(1 -1) rotate(60 18.856 5.196) translate(1 1.5)"/>
                            </g>
                            <path d="M0 0L2 2 4 0" transform="translate(20 6) scale(1 -1) rotate(60 18.856 5.196)"/>
                            <path d="M0 14L2 16 4 14" transform="translate(20 6) scale(1 -1) rotate(60 18.856 5.196) matrix(1 0 0 -1 0 30)"/>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
      </span>
    )
  }
}


export class CookingProductIcon extends Component {
  render() {
    return (
      <span className="" aria-hidden="true">
        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
            <g fill="none" fillRule="evenodd">
                <g stroke="#417171" strokeWidth="2">
                    <rect width="8" height="4" x="15" y="5" rx="1"/>
                    <rect width="24" height="18" x="7" y="9" rx="1"/>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M6 9L32 9M7.5 34L7.5 35M12.5 33L12.5 35M18.5 32L18.5 35M24.5 33L24.5 35M30.5 34L30.5 35"/>
                </g>
            </g>
        </svg>
      </span>
    )
  }
}

export class DishwasherProductIcon extends Component {
  render() {
    return (
      <span className="" aria-hidden="true">
        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
            <g fill="none" fillRule="evenodd">
                <g stroke="#417171" strokeWidth="2">
                    <circle cx="13" cy="26.5" r="9.5"/>
                    <path d="M20 12c1.657 0 3-1.343 3-3 0-1.105-1-2.771-3-5-2 2.229-3 3.895-3 5 0 1.657 1.343 3 3 3zM32 12c1.657 0 3-1.343 3-3 0-1.105-1-2.771-3-5-2 2.229-3 3.895-3 5 0 1.657 1.343 3 3 3zM8 12c1.657 0 3-1.343 3-3 0-1.105-1-2.771-3-5-2 2.229-3 3.895-3 5 0 1.657 1.343 3 3 3zM28 18h7c.552 0 1 .448 1 1v4.5c0 2.485-2.015 4.5-4.5 4.5S27 25.985 27 23.5V19c0-.552.448-1 1-1z"/>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M31.5 28L31.5 34.5M28.5 36L34.5 36"/>
                </g>
            </g>
        </svg>
      </span>
    )
  }
}

export class PointerIcon extends Component {
  render() {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={24}
        height={24}
        viewBox="0 0 24 24"
      >
        <g stroke="#0075f2" strokeWidth={2.564} fill="none" fillRule="evenodd">
          <path d="M12 22c5.333-3.333 8-7.333 8-12a8 8 0 00-16 0c0 4.667 2.667 8.667 8 12z" />
          <circle cx={12} cy={9.5} r={2.5} />
        </g>
      </svg>
    )
  }
}

export class FilterIcon extends Component {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="16" height="16" viewBox="0 0 16 16">
          <defs>
              <path id="ustg7sqbha" d="M2.667 2.667c.368 0 .666.298.666.666v5.058l.862-.862c.235-.235.6-.258.86-.07l.083.07c.234.234.258.6.07.86l-.07.082-2 2c-.234.235-.6.258-.86.07l-.083-.07-.465-.465-.275-.275-1.26-1.26c-.26-.26-.26-.682 0-.942.26-.26.683-.26.943 0l.862.86V3.334c0-.368.298-.666.667-.666zM7.61.125c.26-.187.626-.164.86.07l2 2 .07.083c.188.26.165.626-.07.86l-.082.07c-.26.188-.626.164-.86-.07l-.863-.862v5.057C8.667 7.702 8.369 8 8 8c-.368 0-.667-.298-.667-.667V2.277l-.862.861c-.26.26-.682.26-.942 0-.26-.26-.26-.682 0-.943L7.39.333l.138-.138z"/>
          </defs>
          <g fill="none" fillRule="evenodd">
              <g>
                  <g>
                      <g>
                          <g transform="translate(-363 -399) translate(238 387) translate(125 12) translate(2.667 2.667)">
                              <mask id="uuei1tdtjb" fill="#fff">
                                  <use xlinkHref="#ustg7sqbha"/>
                              </mask>
                              <use fill="#979797" fillRule="nonzero" xlinkHref="#ustg7sqbha"/>
                              <g fill="#FFF" fillRule="nonzero" mask="url(#uuei1tdtjb)">
                                  <path d="M0 0H16V16H0z" transform="translate(-2.667 -2.667)"/>
                              </g>
                          </g>
                      </g>
                  </g>
              </g>
          </g>
      </svg>
    )
  }
}
